import React from "react"
import { DEFAULT_SIZE } from "utils/icons"

const ChevronDownIcon = ({
    size = DEFAULT_SIZE,
    color = "currenColor"
}) => {
	return (
		<svg
            xmlns="http://www.w3.org/2000/svg"
            height={size}
            width={size}
            viewBox="0 0 128 128"
            aria-hidden="true"
        >
            <path fill={color} d="M64 88a3.988 3.988 0 0 1-2.828-1.172l-40-40c-1.563-1.563-1.563-4.094 0-5.656s4.094-1.563 5.656 0L64 78.344l37.172-37.172c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656l-40 40A3.988 3.988 0 0 1 64 88z"/>
        </svg>
	)
}

export default ChevronDownIcon
